import { NavigationItemType } from '@data/types';
import useStore from '@store/store';
import classNames from 'classnames';
import React from 'react';

interface Props extends NavigationItemType {}

const NavigationItem: React.FC<Props> = ({ title, href = '#' }) => {
  const { page, setPage } = useStore();
  const santisedTitle: string = title.toLowerCase().replace(' ', '_');

  return (
    <li>
      <a
        href={href}
        onClick={(event) => {
          event.preventDefault();
          window.scrollTo(0, 0);
          return setPage(santisedTitle);
        }}
        className={classNames(
          'text-blue hover:text-red text-sm font-lightNormal block',
          {
            '!text-red': page === santisedTitle,
          }
        )}
      >
        {title}
      </a>
    </li>
  );
};

export default NavigationItem;
